import { RootPage } from '../page';
import $api from '../../api';
import { ChangelogModel } from '../../models/Gen/TrackableBaseModels';
import languages from '../../utils/languages';
import ColorPicker from '../../components/colorPicker';
import * as siteConfig from '../../site-config/trackableConfig';
import { subscribeModelChange } from '../../ko-utils';
import { listenToPageDirty, resolvePageDirty } from '../../utils/changeTracking';

class AnnouncementDetailView extends RootPage {
    constructor() {
        super();

        ColorPicker();

        this.isDirty = ko.observable(false);

        let me = this;

        this.changelog = ko.observable();
        this.channel = this.getServerSideData('channel');
        this.channels = this.getServerSideData('channels').filter(i => i.displayType == this.channel.displayType);

        this.selectedLanguage = ko.observable(window.auth.project.SupportedLanguages[0]);
        this.selectedLanguage.subscribe((val) => {
            document.dispatchEvent(new CustomEvent('tiny_should_change', {
                detail: {
                    content: this.changelog().content(val)
                }
            }));
        });
        this.supportedLanguages = languages.filter(i => window.auth.project.SupportedLanguages.indexOf(i.alpha2) !== -1);

        if (this.channel.displayType == 1) {
            this.themes = [
                { id: 'default', text: 'Default' },
                { id: 'colored-parallax', text: 'Colored' },
                { id: 'image', text: 'With image' },
                { id: 'hidden', text: 'Hidden' }
            ];
        } else if (this.channel.displayType == 2 || this.channel.displayType == 3) {
            this.themes = [
                { id: 'default', text: 'Default' },
                { id: 'warning', text: 'Warning' },
                { id: 'caution', text: 'Caution' },
                { id: 'custom', text: 'Custom colors' },
            ];
        }

        this.selectedTheme = ko.computed({
            read: () => {
                if (!this.changelog()) return null;

                var curVal = ko.unwrap(this.changelog().themeConfig);

                if (!curVal) {
                    curVal = this.themes[0];
                    //console.log('FSDAFASD', curVal);
                    //this.selectedTheme(curVal.id);
                } else {
                    curVal = this.themes.filter(i => i.id === ko.unwrap(curVal.id));

                    if (curVal.length > 0) curVal = curVal[0];
                }

                return curVal.id;
            },
            write: (val) => {
                if (!this.changelog()) return;

                var themeConfig = this.changelog().themeConfig;

                if (!ko.isObservable(themeConfig)) {
                    this.changelog().themeConfig = ko.observable();
                }

                this.changelog().themeConfig(Object.assign(this.changelog().themeConfig() || {}, { id: val }));

                this.updatePreview();
            }
        });

        this.coloredOptionsShown = ko.observable(false);
        this.imageOptionsShown = ko.observable(false);
        this.customColorsShown = ko.observable(false);

        this.selectedTheme.subscribe(newVal => {
            this.coloredOptionsShown(newVal === 'colored-parallax');
            this.imageOptionsShown(newVal === 'image');
            this.customColorsShown(newVal === 'custom');
        });

        this.themeBodyBgColor = createTitleAppearanceComputed('bodyBgColor');
        this.themeBodyColor = createTitleAppearanceComputed('bodyColor');
        this.themeHeaderBgColor = createTitleAppearanceComputed('headerBgColor');
        this.themeHeaderColor = createTitleAppearanceComputed('headerColor');
        this.themeFooterBgColor = createTitleAppearanceComputed('footerBgColor');
        this.themeFooterColor = createTitleAppearanceComputed('footerColor');

        this.themePrimaryButtonBgColor = createTitleAppearanceComputed('primaryBtnBgColor');
        this.themePrimaryButtonColor = createTitleAppearanceComputed('primaryBtnColor');

        this.backgroundImage = createTitleAppearanceComputed('bgImage');
        this.imgSizing = createTitleAppearanceComputed('imgSizing', 'auto');
        this.imgPosition = createTitleAppearanceComputed('imgPosition', 'top');
        this.imgSpacing = createTitleAppearanceComputed('imgSpacing', '33%');

        const that = this;
        function createTitleAppearanceComputed(titleThemeOpt, defaultValue) {
            const f = ko.observable(0);
            return ko.computed({
                read: () => {
                    const v = f();
                    let opts = getTitleThemeOpts();

                    return opts[titleThemeOpt] || defaultValue;
                },
                write: (val) => {
                    setTitleThemeOpts(o => {
                        o[titleThemeOpt] = val;
                    });
                    f(-1);
                    f(0);

                    that.updatePreview();
                }
            }).extend({ trackChange: { enabler: me.__trackingEnabled, name: 'ChangelogModel.#THEME#.titleThemeOpt' } });;
        }

        function getTitleThemeOpts() {
            try {
                let opts = JSON.parse(ko.unwrap(me.changelog().themeConfig().options));

                return opts || {};
            } catch (e) {
                return {};
            }
        }

        function setTitleThemeOpts(callback) {
            let opts = getTitleThemeOpts();

            callback(opts);

            if (!me.changelog().themeConfig().options) {
                me.changelog().themeConfig().options = ko.observable();
            }

            me.changelog().themeConfig().options(JSON.stringify(opts));
        }

        this.skipPropagatingChangeEvent = ko.observable(false);

        document.addEventListener('changelog_editor_onchange', () => {
            this.updatePreview();
        });

        this.buttonActions = [
            { id: 'url', text: 'Dismiss and Go to URL' },
            { id: 'url_blank', text: 'Dismiss and Go to URL (blank)' },
            { id: 'close', text: 'Only Dismiss' }
        ];

        this.primaryButtonShown = ko.pureComputed({
            read: () => {
                const cfg = ko.unwrap(this.changelog().partialConfig);

                if (!cfg) return false;

                return !!ko.unwrap(cfg.primaryBtn);
            },
            write: (val) => {
                let cfg = ko.unwrap(this.changelog().partialConfig);

                if (!cfg) {
                    cfg = new siteConfig.ChangelogDescriptor();
                    cfg.btnsPos.subscribe(() => { this.updatePreview() });
                    this.changelog().partialConfig(cfg);
                }

                if (val) {
                    const ab = new siteConfig.ActionButton();

                    subscribeModelChange(ab, () => { this.onPrimaryButtonChanged() });

                    cfg.primaryBtn(ab);
                } else {
                    cfg.primaryBtn(null);
                }

                this.updatePreview();
            }
        });

        this.primaryBtnUrlActionSelected = ko.pureComputed(() => {
            const cfg = ko.unwrap(this.changelog().partialConfig);
            const primaryBtn = ko.unwrap(cfg.primaryBtn);

            if (!primaryBtn) return false;

            const action = ko.unwrap(primaryBtn.action);

            return action == 'url' || action == 'url_blank';
        });
    }

    onPrimaryButtonChanged() {
        this.updatePreview();
    }

    onInit() {
        siteConfig.ChangelogDescriptor.prototype._ModelExtender = (model, p, pp, mappingOptions) => {
            mappingOptions.primaryBtn = {
                create: (options) => {
                    const model = new siteConfig.ActionButton(options.data);

                    subscribeModelChange(model, () => { this.onPrimaryButtonChanged() });

                    return model;
                }
            };
        };

        this.changelog(new ChangelogModel(this.getServerSideData('changelog')));
        if (this.changelog().partialConfig()) {
            this.changelog().partialConfig().btnsPos.subscribe(() => { this.updatePreview() });
        }

        this.changelog().themeConfig.notifySubscribers();

        listenToPageDirty((fields) => {
            this.isDirty(true);
        });
    }

    getPreviewConfig() {
        const changelog = this.changelog().toJS();
        const cnt = changelog.contentsObject.filter(i => i.lng == this.selectedLanguage())[0];
        const title = changelog.titlesObject ? changelog.titlesObject.filter(i => i.lng == this.selectedLanguage())[0] : null;

        changelog.content = {
            [this.selectedLanguage()]: cnt ? cnt.content : {}
        }
        changelog.title = {
            [this.selectedLanguage()]: title ? title.content : ''
        }

        changelog.channelId = 1;

        if (this.channel.displayType != 1) {
            changelog.publishedAt = '2050-12-12T10:12:12';
        }

        const partial = ko.unwrap(changelog.partialConfig);

        if (partial) {
            changelog.btnsPos = partial.btnsPos;
            changelog.primaryBtn = partial.primaryBtn;
        }

        return JSON.parse(JSON.stringify(changelog));
    }

    initPreview() {
        setTimeout(() => {
            this.updatePreview();
        }, 1500);
    }

    updatePreview() {
        const cfg = this.getPreviewConfig();

        /** @type {HTMLIFrameElement} */
        const el = document.getElementById('previewer');
        if (!el) return;
        el.contentWindow.postMessage({
            action: 'update',
            type: 'announcement',
            config: cfg,
            language: this.selectedLanguage(),
            displayType: this.channel.displayType
        });
    }

    onBgImageChanged(data, e) {
        const files = e.target.files;

        const file = files[0];

        const filesize = ((files[0].size / 1024) / 1024).toFixed(4);

        if (filesize > 0.8) {
            alert('Image size limit is 800 kB. We recommend compressing your image to provide better experience to your users.');
            return;
        }

        var formData = new FormData();
        formData.append('file', file);
        fetch('/files/' + auth.project.UniqueCode, { method: 'POST', body: formData, credentials: 'include' }).then(resp => {
            resp.json().then(r => {
                this.backgroundImage(r.fileId);
            });
        }, err => {
            alert('Image upload error :(');
        });
    }

    getChangelogFromServer(successCallback) {
        $api.changelogs.get(
            { projectCode: auth.project.UniqueCode, id: this.changelog().id() },
            {},
            (resp) => {
                //console.log('111');
                this.changelog(new ChangelogModel(resp));
                //console.log('222');
                if (successCallback) successCallback(resp);
            }
        );
    }

    publish() {
        this.confirmStandardDialog('Do you really want to publish the announcement?', {
            buttonSet: 'yes',
            success: () => {
                this.startSubmitting('publish');
                this.skipPropagatingChangeEvent(true);

                //$api.changelogs.save(
                $api.changelogs.saveChangelogToChannel(
                    { projectCode: auth.project.UniqueCode, id: this.channel.id },
                    this.changelog().toJS(),
                    (resp) => {
                        $api.changelogs.publish(
                            { projectCode: auth.project.UniqueCode, id: this.changelog().id() },
                            {},
                            (resp) => {
                                TRACK_EVENT('Announcements', 'Published', this.selectedTheme());

                                this.getChangelogFromServer(() => {

                                });

                                this.stopSubmitting('publish');

                                this.isDirty(false);
                                resolvePageDirty();

                                this.closeDialog();
                            }
                        );

                        this.showToast('Announcement saved and published.');
                    }
                );
            }
        });
    }

    unpublish() {
        this.confirmStandardDialog('Do you really want to unpublish the announcement? Once published again, users will see it again.', {
            buttonSet: 'yes',
            success: () => {
                this.startSubmitting('unpublish');
                this.skipPropagatingChangeEvent(true);
                $api.changelogs.unpublish(
                    { projectCode: auth.project.UniqueCode, id: this.changelog().id() },
                    {},
                    (resp) => {
                        TRACK_EVENT('Announcements', 'Unpublished');
                        this.stopSubmitting('unpublish');
                        this.getChangelogFromServer(() => {

                        });

                        this.isDirty(false);
                        resolvePageDirty();

                        this.showToast('Changelog unpublished.');

                        this.closeDialog();
                    }
                );
            }
        });
    }

    save() {
        this.startSubmitting('save');
        this.skipPropagatingChangeEvent(true);
        $api.changelogs.saveChangelogToChannel(
            { projectCode: auth.project.UniqueCode, id: this.channel.id },
            this.changelog().toJS(),
            (resp) => {
                this.stopSubmitting('save');
                this.getChangelogFromServer(() => {

                });
                this.showToast('Announcement saved.');

                this.isDirty(false);
                resolvePageDirty();
            }
        );
    }

    remove(item) {
        this.confirmStandardDialog('Do you really want to delete this announcement?', {
            success: () => {
                $api.changelogs.remove(
                    { projectCode: window.auth.project.UniqueCode, id: this.changelog().id() },
                    {},
                    () => {
                        TRACK_EVENT('Announcements', 'Removed');

                        window.location.href = `/${window.auth.project.UniqueCode}/announcements/overview`;
                    }
                );
            }
        });
    }

    switchEditingLanguage(lng) {
        this.selectedLanguage(lng);

        return true; // must be here to allow bubbling (because of the inner checkbox)
    }

    bindLocalizableProp(observable) {
        return ko.computed({
            read: () => {
                var val = ko.unwrap(observable);
                if (!val) {
                    return undefined;
                }

                return ko.unwrap(observable()[this.selectedLanguage()]);
            },
            write: (val) => {
                var curV = ko.unwrap(observable);

                if (!curV) {
                    curV = {};
                }

                curV[this.selectedLanguage()] = val;

                typeof observable === 'function' && observable(curV);
            }
        });
    }
}

export default AnnouncementDetailView;